import _ from 'lodash';

import { Terminal } from '../../api/terminals';
import { Logger } from '../../logs/Logger';
import { WebsocketCommandResponse } from '../MainWebsocketCommands';
import { WebsocketCommand, WebsocketCommandResponseStatus } from '../useManagedWebsocket';
import { sendPayloadsWithDelay } from '../utils/PacedSender';

export class WebsocketRequestLogsCommand extends WebsocketCommand {
    public async execute(terminal: Terminal | null, websocket: WebSocket): Promise<WebsocketCommandResponse> {
        Logger.getLogs().then(async (logs) => {
            const chunks = _.chunk(logs, 100);
            const payloads = chunks.map((cl) => ({
                message: cl,
                status: WebsocketCommandResponseStatus.SUCCESS,
                command: this.type,
                terminal: terminal,
            }));
            await sendPayloadsWithDelay(websocket, payloads, 50);
            logs && Logger.removeById(logs.map((l) => l.raw_data.id));
        });
        return { success: true };
    }
}
